import { edit } from "../../slices/settingsSlice";
import Title from "../navigation/Title";
import ButtonSwitch from "../form/ButtonSwitch";
import { Grid } from "@mui/material";

export default function SettingsAI(props){
    const { isLoading } = props;

    return (
        <div className="settings-ai">
            <Title
                title="AI Settings"
                fontSize={22}
                sx={{
                    marginBlock: "20px",
                }}
            />
            <div className="settings-card">
                <Title
                    title="AI Content Generation"
                    fontSize={20}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiVideoTitle"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Video title"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiVideoDescription"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Video description"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiGalleryTitle"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Gallery title"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiGalleryDescription"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Gallery description"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiChannelShortDescription"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Channel short description"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiChannelDescription"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Channel description"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <ButtonSwitch
                            stateName="settings"
                            valueName="aiModelBiography"
                            dispatchFunc={edit}
                            disabled={isLoading}
                            label={"Model biography"}
                            data={[
                                { id: "true", label: "Enabled", color: "green" },
                                { id: "false", label: "Disabled", color: "red" }
                            ]}
                        />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}